import { render } from "./links.vue?vue&type=template&id=0775dc69&scoped=true"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"

import "./links.vue?vue&type=style&index=0&id=0775dc69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EDZ\\WebstormProjects\\one-nav-simple-theme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775dc69"]])

export default __exports__